// apps/client/src/client/services/souscription/use-souscription-stats.ts

import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";
export interface SouscriptionStats {
  active: number;
  expired: number;
  total: number;
}

export const fetchSouscriptionStats = async (): Promise<SouscriptionStats> => {
  const response = await axios.get<SouscriptionStats>("/souscription/stats");
  return response.data;
};

export const useSouscriptionStats = () => {
  return useQuery({
    queryKey: ["souscriptionStats"],
    queryFn: fetchSouscriptionStats,
  });
};

export interface PieData {
  label: string;
  value: number;
}

export const fetchSouscriptionsByRate = async (from?: Date, to?: Date): Promise<PieData[]> => {
  const params = { from: from?.toISOString(), to: to?.toISOString() };
  const response = await axios.get<PieData[]>("/souscription/by-rate-pie", {
    params,
    paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
  });
  return response.data;
};

export const useSouscriptionsByRate = (from?: Date, to?: Date) => {
  return useQuery({
    queryKey: ["souscriptionsByRate", from, to],
    queryFn: () => fetchSouscriptionsByRate(from, to),
    enabled: true,
  });
};
